import auth from '@/common/auth/auth';
import ApiHandler from '@/common/api/api-handler';

export default new ApiHandler({auth});
